var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumbs',{attrs:{"route":_vm.additionalRoute}}),_c('transition',{attrs:{"name":"fade","appear":"","mode":"out-in"}},[_c('router-view',{on:{"update:throwRouteName":_vm.setAdditionalRoute}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }